<template>
    <div class="super-million">
        <SportCallerBase
            :url="url"
            @redirect="handleRedirect"
        />
    </div>
</template>

<script>
    import { getConfig } from '@superbet-group/web.lib.config';

    import SportCallerBase from '../SportCallerBase.vue';

    export default {
        data() {
            return {
                url: getConfig().superMillion.url,
            };
        },
        methods: {
            handleRedirect(data) {
                const url = new URL(data.url);
                const path = `${url.pathname}${url.search}`;
                this.$router.push({ path: path });
            },
        },
        components: {
            SportCallerBase,
        },
    };
</script>
